export const enum PortfolioLoanStatus {
  PASS = 'PASS',
  REVIEW = 'REVIEW',
  FAIL = 'FAIL',
  DELETE = 'DELETE'
}
export const enum PortfolioLoanStatusCode {
  ENTERED = 'Entered',
  RECEIVED = 'Received',
  CANCELLED = 'Cancelled',
  REJECTED = 'Rejected',
  REFUSED = 'Refused',
  WITHDRAWN = 'Withdrawn',
  APPROVED = 'Approved',
  ISSUE = 'Issue',
  RISKED = 'Risked',
  FINALIZED = 'Finalized',
  SAVED = 'Saved',
  PRICED = 'Priced',
  OFFER = 'Offer',
  LOCK = 'Lock',
  EXPIRED = 'Expired',
  NEW = 'New',
  RERISK = 'Rerisk',
  CRITICAL = 'Critical'
}

export const PortfolioLoanStatusColorMap: Record<PortfolioLoanStatus, string> = {
  [PortfolioLoanStatus.PASS]: '#4CAF50',
  [PortfolioLoanStatus.REVIEW]: '#FF9800',
  [PortfolioLoanStatus.FAIL]: '#F44336',
  [PortfolioLoanStatus.DELETE]: '#000000'
};
export const PortfolioLoanStatusCodeNameMap: Record<PortfolioLoanStatusCode, string> = {
  [PortfolioLoanStatusCode.APPROVED]: '#4CAF50',
  [PortfolioLoanStatusCode.RISKED]: '#FF9800',
  [PortfolioLoanStatusCode.CANCELLED]: '#202428',
  [PortfolioLoanStatusCode.REJECTED]: '#783B03',
  [PortfolioLoanStatusCode.ENTERED]: '#697885',
  [PortfolioLoanStatusCode.RECEIVED]: '#783B03',
  [PortfolioLoanStatusCode.REFUSED]: '#783B03',
  [PortfolioLoanStatusCode.WITHDRAWN]: '#202428',
  [PortfolioLoanStatusCode.ISSUE]: '#783B03',
  [PortfolioLoanStatusCode.FINALIZED]: '#447F00',
  [PortfolioLoanStatusCode.SAVED]: '#997F26',
  [PortfolioLoanStatusCode.PRICED]: '#997F26',
  [PortfolioLoanStatusCode.OFFER]: '#009B74',
  [PortfolioLoanStatusCode.LOCK]: '#997F26',
  [PortfolioLoanStatusCode.EXPIRED]: '#202428',
  [PortfolioLoanStatusCode.NEW]: '#483FCD',
  [PortfolioLoanStatusCode.RERISK]: '#997F26',
  [PortfolioLoanStatusCode.CRITICAL]: '#DA291C'
};

export const getPortfolioLoanStatusColor = (codeName: string | undefined): string => {
  if (!codeName) return '';

  const color = PortfolioLoanStatusColorMap[codeName as PortfolioLoanStatus];
  return color || '';
};

export const getPortfolioLoanStatusCodeColor = (codeName: string | undefined): string => {
  if (!codeName) return '';

  const color = PortfolioLoanStatusCodeNameMap[codeName as PortfolioLoanStatusCode];
  return color || '';
};
